import React from "react";
import Header from "../Header/header";
import Section from "../Projects/projects";
import Container from "react-bootstrap/Container";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import styles from "./app.module.css";
import { Card } from "@material-ui/core";


function Home() {
  return (
      <Container fluid='xl' className={styles.container}>
        {1}
          <Header/>
         <br>
         </br>
        <Section />
      </Container>
  );
}

export default Home;